import { Dispatch, SetStateAction, createContext } from 'react';
import {
  DataRoomBuySideGroup,
  DataRoomMember,
} from '../../models/DataRoomMember';
import utils from 'utils';
import {
  DataRoomShareableLink,
  DataRoomShareableLinkRequest,
} from 'models/ShareableLink';

type MembersContextProps = {
  isLoading: boolean;
  allMembers: DataRoomMember[];
  sellSideMembers: DataRoomMember[];
  sellSideNewMembers: DataRoomMember[];
  buySideGroups: DataRoomBuySideGroup[];
  buySideGroupWithNewMembers: DataRoomBuySideGroup[];
  buySideMembers: DataRoomMember[];
  buySideNewMembers: DataRoomMember[];
  requestedMembersCount: number;
  isLoadingWaitingList: boolean;
  waitingRoomItems: DataRoomShareableLinkRequest[];
  waitingRoomItemsCount: number;
  isLoadingWaitingListExpired: boolean;
  waitingRoomItemsExpired: DataRoomShareableLinkRequest[];
  waitingRoomItemsExpiredCount: number;
  waitingRoomCount: number;
  updateShareableLinkInWaitingItem: (
    dataRoomShareableLink: DataRoomShareableLink,
  ) => void;
  removeWaitingRoomItem: (itemId: string) => void;
  removeWaitingRoomItemExpired: (itemId: string) => void;
  removeWaitingRoomSecureLinkExpired: (shareableLinkId: string) => void;
  setSellSideMembers: Dispatch<SetStateAction<DataRoomMember[]>>;
  setBuySideGroups: Dispatch<SetStateAction<DataRoomBuySideGroup[]>>;
  updateMember: (updatedMember: Partial<DataRoomMember>) => void;
  updateBuySideGroup: (group: DataRoomBuySideGroup) => void;
};

export default createContext<MembersContextProps>({
  isLoading: false,
  allMembers: [],
  sellSideMembers: [],
  sellSideNewMembers: [],
  buySideGroups: [],
  buySideGroupWithNewMembers: [],
  buySideMembers: [],
  buySideNewMembers: [],
  requestedMembersCount: 0,
  isLoadingWaitingList: false,
  waitingRoomItems: [],
  waitingRoomItemsCount: 0,
  isLoadingWaitingListExpired: false,
  waitingRoomItemsExpired: [],
  waitingRoomItemsExpiredCount: 0,
  waitingRoomCount: 0,
  updateShareableLinkInWaitingItem: utils.noop,
  removeWaitingRoomItem: utils.noop,
  removeWaitingRoomItemExpired: utils.noop,
  removeWaitingRoomSecureLinkExpired: utils.noop,
  setSellSideMembers: utils.noop,
  setBuySideGroups: utils.noop,
  updateMember: utils.noop,
  updateBuySideGroup: utils.noop,
});
